import type { TFunction } from 'i18next';
import type { ConversationExpertReportStatus } from '@/entities/conversations';
import type { EvaluationRuleResult, VerificationStatus } from './api/types';

/** Результат правила в заключении по диалогу. */
export type EvaluationRuleResultCode = EvaluationRuleResult['result'];

/** Все результаты правила — в порядке показа пользователю при отборе правил. */
export const EVALUATION_RULE_RESULTS: readonly EvaluationRuleResultCode[] = ['fail', 'success', 'comment', 'partial'];

export const EXPERT_REPORT_STATUS = {
  NEW: 'NEW',
  IN_PROCESS: 'IN_PROCESS',
  DONE: 'DONE',
  ERROR: 'ERROR',
} as const;

export type ExpertReportStatus = keyof typeof EXPERT_REPORT_STATUS;

export const getExpertReportStatusLabel = (
  t: TFunction<['dialogs']>,
  status: ConversationExpertReportStatus,
): string => {
  switch (status) {
    case 'NEW':
      return t('dialogs:expertReport.status.new' as never);
    case 'IN_PROCESS':
      return t('dialogs:expertReport.status.inProcess' as never);
    case 'DONE':
      return t('dialogs:expertReport.status.done' as never);
    case 'ERROR':
      return t('dialogs:expertReport.status.error' as never);
    default:
      return status;
  }
};

/** Стадии проверки результата заключения человеком — в порядке её хода. */
export const VERIFICATION_STATUSES: readonly VerificationStatus[] = ['NEW', 'IN_PROGRESS', 'CONFIRMED'];

/** Ключи названий стадий проверки: коды приходят с сервера, названия живут в переводах. */
const VERIFICATION_STATUS_LABEL_KEYS: Record<VerificationStatus, string> = {
  NEW: 'new',
  IN_PROGRESS: 'inProgress',
  CONFIRMED: 'confirmed',
};

export const getVerificationStatusLabel = (t: TFunction<['dialogs']>, status: VerificationStatus): string =>
  t(`dialogs:expertReport.verificationStatus.${VERIFICATION_STATUS_LABEL_KEYS[status]}` as never);
